module.exports = __webpack_public_path__ + "img/valecaja-icon.5dc8a50a.png";